/* istanbul ignore next */
document.addEventListener('DOMContentLoaded', () => {
    try { main(); } catch (err) { console.error(err); }
});

export default function main(): void {
    arrayFrom('[data-knock]').forEach((el): void => {
        el.addEventListener('click', (): void => {
            const knockedKey = el.getAttribute('data-knock') as SecretKnockKey;
            onSecretKnock(knockedKey);
        });
    });

    /* istanbul ignore next */
    if (localStorage.getItem('showDebugLinks')) {
        showLinksContainer();
    }

    /* istanbul ignore next */
    arrayFrom('[data-click-action="hide-links-container"]').forEach((el): void => {
        el.addEventListener('click', (): void => {
            localStorage.removeItem('showDebugLinks');
            showLinksContainer(false);
        });
    });
}

let knockCounter = 0;
const knockKeys = ['copyright', 'almost', 'how'];

function onSecretKnock(key: SecretKnockKey): void {
    const expected = knockKeys[knockCounter];

    if (key !== expected) knockCounter = -1;

    if (knockCounter === -1) return;

    knockCounter += 1;

    if (knockKeys.length <= knockCounter) {
        knockCounter = 0;

        showLinksContainer();
        localStorage.setItem('showDebugLinks', '1');
    }
}

function arrayFrom<T extends Element>(selector: string): T[] {
    return Array.from<T>(document.querySelectorAll(selector));
}

function showLinksContainer(show = true): void {
    arrayFrom('[data-debug-links-container]').forEach((el): void => {
        if (show) el.classList.remove('d-none');
        else el.classList.add('d-none');
    });
}

declare global {
    interface Window {
        // 'urls' - Defined in main.ts. Exposed via index.html
        urls: Record<string, string>;
    }
}

type SecretKnockKey = 'copyright' | 'almost' | 'how';
